import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { tap, catchError, retry } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AdminService } from './admin.service';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
    private admin: AdminService,
    private errorHandler: ErrorHandlerService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Check token expiration before making request
    const expiresAt = localStorage.getItem('token_expires_at');
    if (expiresAt && new Date(expiresAt) <= new Date()) {
      this.admin.logout();
      return throwError('Token expired');
    }

    if (this.admin.showLoader) {
      this.admin.loader(true);
    }

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.admin.loader(false);
        }
      }),
      catchError((err: HttpErrorResponse) => {
        this.admin.loader(false);

        if (err.status === 401) {
          this.admin.logout();
          this.admin.error('Session expired. Please login again.');
        } else {
          const message = this.errorHandler.getErrorMessage(err);
          this.admin.errorAlert(message, false);
        }

        const error = err.error?.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
